import React, { useEffect } from "react";
import gsap from "gsap";
import Circlebutton from "../components/Circlebutton";
import Viewbutton from "../components/Viewbutton";
import Bloghome from "../components/Bloghome";
import Portfoliocarousel from "../components/Portfoliocarousel";
import Services from "../components/Services";
export default function Home() {
    useEffect(() => {
        gsap.from(".header-content", {
            opacity: 0,
            duration: 2,
            ease: "power3.out",
            stagger: 0.3,
        });
    }, []);
    return (
        <div>
            <div className="home-header">
                <div className="header-content">
                    <div className="header-intro">
                        <h1 className="name">
                            Graduaat <br></br> Programmeren
                        </h1>
                        <div className="occupation-container">
                            <ul className="occupation">
                                <li className="occupation-item">Fun</li>
                                <li className="occupation-item">Coding</li>
                                <li className="occupation-item">Hello world</li>
                            </ul>
                        </div>
                        <p className="header-description">
                            Tijdens het Graduaat Programmeren leer je het
                            zichtbare (front-end) en onzichtbare (backend) deel
                            van web- en mobiele toepassingen ontwikkelen. Je
                            wordt specialist in JavaScript, HTML, CSS en vult
                            jouw skills aan met o.a. PHP, Python, UI/UX. Naast
                            deze technische kant, vergaar je ook algemene
                            ICT-skills. Je leert ook hoe digital agencies werken
                            en wat jouw rol hierbinnen zal zijn. Na deze
                            opleiding kan je aan de slag als front-end
                            developer, full-stack JavaScript developer, PHP
                            developer, Web Designer + Coder of CMS Themer.
                        </p>
                        <Circlebutton />
                    </div>
                    <div className="header-pics">
                        <img
                            src="img/header.jpg"
                            alt="graphic element"
                            className="overlap-img"
                        />
                    </div>
                </div>
            </div>
            <div className="main-container">
                <div className="portfolio-home seperate" id="about">
                    <div className="port-content">
                        <h1>Portfolios</h1>
                        <p>
                            Ontdek het studentenwerk van het graduaat
                            Programmeren! Benieuwd wat onze programmeurs
                            uitspoken in de cloud? Of wat ze kunnen maken met
                            HTML, CSS, JavaScript Node.js, PHP en veel meer? Je
                            vindt het allemaal op dit portfolio platform.
                        </p>
                        <Viewbutton url={{ link: "project" }}></Viewbutton>
                    </div>
                    <Portfoliocarousel />
                </div>

                <div className="blog-home seperate">
                    <Bloghome />
                    <Viewbutton url={{ link: "blog" }}></Viewbutton>
                </div>

                <div className="services-home seperate">
                    <h1>Diensten</h1>
                    <p className="card-description">
                        Welke diensten leveren we?
                    </p>
                    <Services />
                    <Viewbutton url={{ link: "services" }}></Viewbutton>
                </div>
            </div>
        </div>
    );
}
